import { createRouter, createWebHistory } from "vue-router"

import MainIndex from "@/views/MainIndex";
import LiangHao from "@/views/LiangHao";

import OrderResult from "@/views/OrderResult";

let titlePre = '我爱号码网';
let path = window.location.href;
if(path.indexOf("xiaotel.com") != -1){
    titlePre = '杭州估的好科技';
}else if(path.indexOf("52tongxun.com") != -1){
    titlePre = '百亿通信网';
}else if(path.indexOf("52taocan.com") != -1){
    titlePre = '我爱套餐网';
}


const routes = [
    {
        path: "/lianghao",
        component:LiangHao,
        meta:{
            title: titlePre+'-手机靓号选号预约办理'
        }
    },
    {
        path: "/proxy/:source",
        component:MainIndex,
        meta:{
            title: titlePre+'-手机靓号-可私人定制'
        }
    },
    {
        path: "/:source",
        component:MainIndex,
        meta:{
            title: titlePre+'-宽带办理'
        }
    },

    {
        path: "/order-result/:orderId",
        component:OrderResult,
        meta:{
            title: titlePre+'下单结果'
        }
    },
    {
        path: "/",
        redirect: "/52haoma"
    }


];



const router = createRouter({
    history: createWebHistory('/'),
    routes
});

export default router;